"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentageText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_number_format_1 = __importDefault(require("react-number-format"));
exports.PercentageText = react_1.default.memo(function (_a) {
    var value = _a.value;
    return ((0, jsx_runtime_1.jsx)(react_number_format_1.default, { "data-testid": "percentage", value: value, suffix: "%", displayType: "text" }));
});
